import { render, staticRenderFns } from "./FeeRuleSetting.vue?vue&type=template&id=208fed9e&"
import script from "./FeeRuleSetting.vue?vue&type=script&lang=ts&"
export * from "./FeeRuleSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports